'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
    var label = _ref.label,
        labelClassNames = _ref.labelClassNames,
        required = _ref.required,
        id = _ref.id;

    var mergedLabelClassNames = (0, _classnames2.default)('luna-label', labelClassNames, {
        'luna-label--fluid': required
    });
    return _react2.default.createElement("label", { className: mergedLabelClassNames, htmlFor: id }, label, required && _react2.default.createElement("span", { className: "luna-label__secondary" }, "Required field"));
};
exports.default = Label;
//# sourceMappingURL=Label.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/Label.js